export default (params) => ({
  trigger: {
    name: 'search.read_reviews_in_typeahead',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'read_reviews',
      params: {
        sub_feature: 'typeahead',
      },
    },
  },
});
